<template>
  <div class="userLogin bg">
    <div class="bg-blue"></div>
    <div id="userLogin">
        <div class="avatar">
          <img src="@/assets/xxtx.jpg" >
        </div>
        <form>
          <div class="mb-20">
            <keep-alive>
              <se-autocomplete
                v-model="iccid"
                :fetchsuggestions="querySearch"
                @select="handleSelect"
                placeholder="请输入卡板上的数字（有字母的需要带字母）"
              ></se-autocomplete>
            </keep-alive>
          </div>
             <p style="text-align: center;font-size: 13px;margin-top:1rem;color:red"></p>
          <div class="formLine mb-20" >
            <mt-button type="primary" size="large" @click.prevent="userQuerySIM">查询办理</mt-button
            >
            <br/>
               <br/>
              <div  style="color: #1989fa;width:70px;margin:0 auto;" >
                    <p>
            <a href="javascript: void(0);"
            @click="guanzhu()">上 级 目 录</a>
                </p>
                </div> 
          </div>
        </form>
             <p style="text-align: center;font-size: 16px;margin-top:1rem;color:red">温馨提醒：本产品暂无通话短信功能！ 请务必扫码关注公众号 方便后期查询及充值</p>
        <div class="msg">
      <img style="width:100%;" src="@/assets/kefu/kefu4.png" />
        </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  components: { SeAutocomplete, Advertisement },
  data() {
    return {
      showimg:false,
      iccid: "",
      code: "",
      showAds: true,
      gzh: ""
    };
  },
  methods: {
    guanzhu(){
        window.location.href='http://webchat.szxxtx.com/#/user/service';
    },
       kefuURl(){
      window.location.href='https://work.weixin.qq.com/kfid/kfc936d6fd76f9e8553?enc_scene=ENCGh9rMoMTyL4LpCZxr4rRS9cEQASjTFHye1UzncGz72YL'
    },
    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData("iccidList");
      var results = queryString
        ? listAll.filter(this.createFilter(queryString))
        : listAll;
      cb(results);
    },
    createFilter(queryString) {
      return listAll => {
        return listAll.indexOf(queryString) == 0;
      };
    },
    handleSelect(item) {
      this.iccid = item;
    },
    userQuerySIM() {
      // Dialog({ message: '系统维护中' });
      // return;
      if (!this.iccid || this.iccid == "") {
        Dialog.alert({ title: "提示", message: "请输入ICCID号" });
        return false;
      }

      let recordLoginText = this.iccid; //存放用户登录时输入的文本，将用于首页显示

      let data = {
        requestId: this.iccid,
        code: this.code
      };
      wxRequest("sim/bind", data, "get").then(res => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;

          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("intoNo", record.intoNo);

          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          // this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);
           localStorage.setItem("iccid", iccid);
          this.$store.state.intoNo = record.intoNo;
          sessionStorage.setItem("intoNo", record.intoNo);
          this.setAutoCompleteData("iccidList", recordLoginText, 10);
          //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          let cardType = record.supplierTypeCode;
          let _data = { iccid: record.iccid };
          	wxRequest("sim/is/have/pkg", {iccid: iccid}, "get").then(res => {
             if(res.data.code == 200){
               this.$router.replace("/user/home");
			       }else{
               if(record.basePkgGroup=='1547757996434518016'){//熊猫卡
                   this.$router.push({
						path: '/user/openPriceSim',
						query: {
							iccid: iccid
						}})
               }else{
                  this.$router.push({
						path: '/user/cardOpens',
						query: {
							realNameCard: 1
						}})
               }
               
             }
        })       
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    goto(path) {
      //广告点击统计
      window.location.href = path;
    }
  },
  created() {
    var source = this.getQueryVariable("source")
      ? this.getQueryVariable("source")
      : process.env.VUE_APP_APPID;
    localStorage.setItem("appid", source);
    localStorage.setItem("isHeadquarterAppid", false);
    var appid = source ? source : process.env.VUE_APP_APPID;

    console.log(appid);
    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx18b33905435d410b&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
      this.iccid = localStorage.getItem("recordLoginText");

      //自动登录
      // if(this.iccid){
      //     this.userQuerySIM();
      // }
    }

    //获取总部公众号appid
    wxRequest("sim/appId", {}, "post").then(res => {
      if (res.data.code == 200) {
        if (appid != res.data.data.collectAppid) {
          this.$store.commit("setIsHeadquarterAppid", "false");
          localStorage.setItem("isHeadquarterAppid", false);
        } else {
          this.$store.commit("setIsHeadquarterAppid", "true");
          localStorage.setItem("isHeadquarterAppid", true);
        }
      }
    });
  },

  mounted() {},

  beforeDestory() {}
};
</script>
<style lang="less">
.userLogin{
  .mint-button--primary{
    background-color: #5ab1f6;
    .mint-button-text{
      font-size:14px;
    }
  }
  #userLogin input[type=text]{
    background-color: #F5F5F5;
    border:none;
    border-radius: 4px;
    &::-webkit-input-placeholder {
      color: #C1C1C1;
      text-align: center;
    }
  }
}
</style>
<style lang="less" scoped>
.userLogin {
  min-height: 100vh;
  .bg-blue {
    height: 130px;
    background-color: #5ab1f6;
  }
  #userLogin {
    width: 95%;
    position: absolute;
    top: 20px;
    left: 2.5%;
    background: #fff;
    border-radius: 8px;
    padding: 20px 15px 50px;
    box-sizing: border-box;
    .avatar{
      text-align: center;
      margin-bottom:30px;
      img{
        width:160px;
        height:160px;
         border-radius: 50%;
      }
    }
  }
  .msg{
    height:30px;
    line-height:30px;
    background-color: #FEF1EB;
    color: #FB6B29;
    font-size: 12px;
     border-radius: 7px;
     padding: 0 10px;
    img{
      width: 12px;
      vertical-align: middle;
      margin-right: 2px;
    }
  }
}

.download {
  position: relative;
  top: -63px;
  background: #ff9c3c;
  border: none;
  padding: 7px 13px;
  border-radius: 25px;
  font-size: 12px;
  color: #fff;
  left: 20%;
}
</style>
